var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Test Tableau")]),_c('iframe',{attrs:{"width":"1000","height":"600","src":_vm.link}})])}
var staticRenderFns = []

export { render, staticRenderFns }